const category = 'Question';

export const WebinarQuestionEvent = {
    WEBINAR_SHOWN: { category, event: 'Webinar participation screen shown' },
    WEBINAR_SKIPPED: { category, event: 'Webinar participation skipped' },
    WEBINAR_YES: { category, event: 'Webinar participation Yes clicked' },
    WEBINAR_NO: { category, event: 'Webinar participation No clicked' },
    WEBINAR_VIDEO_CLICKED: { category, event: 'Video tutorials clicked when replying No for webinar' },
};
